import {
  ParagraphSectionLayout,
  ParagraphTitle,
  TableContainer,
  TableRowContainer,
  TableShellTitle,
  TableShellValue,
} from "@frontend/common";

import EditableTextContainer from "@EditArticleContainer/shared/components/EditableTextContainer/EditableTextContainer";
import { DEALS_PARAGRAPH_CODE } from "@EditArticleContainer/shared/constants/editArticle.constants";
import { useParagraphEditedData } from "@EditArticleContainer/shared/hooks/useParagraph";
import { useUpdateParagraph } from "@EditArticleContainer/shared/hooks/useUpdateParagraph";
import {
  REF_CODE_MA_STRUCTURE_MECHANICAL,
  REF_CODE_MA_STRUCTURE_NOTES,
  REF_CODE_MA_STRUCTURE_TAGS,
} from "@EditArticleContainer/shared/libs/refCode/constants/refCode.constants";
import { createMultiLineText } from "@utils/createMultiLineText/createMultiLineText";

import * as S from "./DealsParagraphMAStructure.style";

const PARAGRAPH_TITLE = "M&A Structure";
const VALUE_SHELL_PADDING = "0.2rem";
const EDITABLE_TEXT_STYLE = { borderRadius: "0" };

const DealsParagraphMAStructure = () => {
  const paragraph = useParagraphEditedData(DEALS_PARAGRAPH_CODE.maStructure);
  const [updateParagraph, loadingIndex, updateKeyMap] = useUpdateParagraph({
    paragraphCode: DEALS_PARAGRAPH_CODE.maStructure,
    sectionCode: "TY002",
  });

  if (!paragraph) return null;

  const structure = paragraph.text["Deal Structure"];
  const mechanicalText =
    structure["Mechanical Structure"].value.at(0)?.text ?? "";
  const mechanicalLabels =
    structure["Mechanical Structure"].value.at(0)?.labels ?? [];
  const tagsText = createMultiLineText({
    textList: structure["Structural Tags"].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });
  const tagsLabels = structure["Structural Tags"].value.at(0)?.labels ?? [];
  const notesText = structure["Structural Notes"].value.at(0)?.text ?? "";
  const notesLabels = structure["Structural Notes"].value.at(0)?.labels ?? [];

  return (
    <ParagraphSectionLayout className="sub-section-wrapper">
      <ParagraphTitle title={PARAGRAPH_TITLE} type="section" />
      <S.ParagraphMAStructureWrapper key={updateKeyMap.get(0)}>
        <S.ParagraphMAStructureUpdateButton
          disabled={loadingIndex === 0}
          onClick={() => updateParagraph(0)}
        />
        <TableContainer>
          <TableRowContainer>
            <TableShellTitle>Mechanical Structure</TableShellTitle>
            <TableShellTitle>Structure Tags</TableShellTitle>
            <TableShellTitle>Structural Notes</TableShellTitle>
          </TableRowContainer>
          <TableRowContainer>
            <TableShellValue padding={VALUE_SHELL_PADDING}>
              <EditableTextContainer
                className="ma-structure-value-text"
                item={{ text: mechanicalText, labels: mechanicalLabels }}
                refKey={REF_CODE_MA_STRUCTURE_MECHANICAL}
                canTextEdit
                style={EDITABLE_TEXT_STYLE}
              />
            </TableShellValue>
            <TableShellValue padding={VALUE_SHELL_PADDING}>
              <EditableTextContainer
                className="ma-structure-value-text"
                item={{ text: tagsText, labels: tagsLabels }}
                refKey={REF_CODE_MA_STRUCTURE_TAGS}
                canTextEdit
                style={EDITABLE_TEXT_STYLE}
              />
            </TableShellValue>
            <TableShellValue padding={VALUE_SHELL_PADDING}>
              <EditableTextContainer
                className="ma-structure-value-text"
                item={{ text: notesText, labels: notesLabels }}
                refKey={REF_CODE_MA_STRUCTURE_NOTES}
                canTextEdit
                style={EDITABLE_TEXT_STYLE}
              />
            </TableShellValue>
          </TableRowContainer>
        </TableContainer>
      </S.ParagraphMAStructureWrapper>
    </ParagraphSectionLayout>
  );
};

export default DealsParagraphMAStructure;
